/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Art_HeadingInputs */

const en_svc_research_art_heading = /** @type {(inputs: Svc_Research_Art_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Is this logistics firm a fit for us?”`)
};

const lv_svc_research_art_heading = /** @type {(inputs: Svc_Research_Art_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Vai šis loģistikas uzņēmums mums der?”`)
};

/**
* | output |
* | --- |
* | "“Is this logistics firm a fit for us?”" |
*
* @param {Svc_Research_Art_HeadingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_art_heading = /** @type {((inputs?: Svc_Research_Art_HeadingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Art_HeadingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_art_heading(inputs)
	return en_svc_research_art_heading(inputs)
});